import { makeStyles } from "@material-ui/core/styles";
export default makeStyles({
    notificationCount: {
        color: "black",
    },
    notificationHeader: {
        textAlign: "left",
        fontWeight: "bold",
        fontSize: "18px",
        color: "#212121",
        paddingTop: "4px",
        paddingLeft: "14px",
    },
    showReadOnlyText: {
        paddingTop: "10px",
        paddingLeft: "30px",
        color: "#707070",
        fontSize: "12px",
        fontWeight: 300,
    },
    dayTime: {
        color: "#9c9c9c",
        fontSize: "12px",
        fontWeight: 300,
    },
    toggle: {
        paddingTop: "16px",
        paddingLeft: "10px",
        position: "relative",
        bottom: "5px",
        cursor: "pointer",
    },
    horizontalDivider: {
        width: "92%",
        height: "1px",
        border: "solid 0.5px rgba(0, 0, 0, 0.12)",
    },
    notificationRow: {
        color: "#212121",
        fontSize: "14px",
        lineHeight: "19px",
        whiteSpace: "break-spaces",
        wordBreak: "break-word",
    },
    notificationText: {
        "&:hover": {
            textDecoration: "underline",
        },
    },
    notificationRead: {
        "&:hover": {
            textDecoration: "none",
        },
    },
    disableClick: {
        pointerEvents: "none",
    },
    notificationMenu: {
        overflow: "visible",
        padding: 0,
    },
    clickMore: {
        fontSize: "12px",
        fontWeight: 300,
        lineHeight: "1.17",
        textAlign: "left",
        color: "#212121",
        cursor: "pointer",
        "&:hover": {
            opacity: 0,
            backgroundColor: "black",
        },
    },

    nfArrow: {
        position: "relative",
        borderBottom: `1px solid rgba(212, 208, 208, .54)`,
        minHeight: "calc(100vh - 310px)",
        "&:after": {
            content: " ",
            position: "absolute",
            right: "30px",
            top: "-15px",
            borderTop: "none",
            borderRight: "15px solid transparent",
            borderLeft: "15px solid transparent",
            borderBottom: "15px solid black",
        },

        //'&:hover': {
        //  backgroundColor: 'red'
        //}
    },
    paper: {
        top: "58px !important",
        filter: "drop-shadow(0px 10px 8px rgba(0,0,0,0.32))",
        width: "400px",
        minHeight: "100px",
        maxHeight: "370px",
        // padding: "20px 0",
        borderRadius: "8px",
        borderShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
        "&::-webkit-scrollbar": {
            width: "5px",
            border: "solid 1px rgba(0, 0, 0, 0)",
        },
        "&::-webkit-scrollbar-track": {
            boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
            webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
            marginTop: "10px",
            marginBottom: "10px",
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "rgba(0,0,0,.2) !important",
            outline: "1px solid rgba(0,0,0,.2)",
        },
        "& .MuiMenu-paper:after": {
            content: " ",
            position: "absolute",
            right: "30px",
            top: "-15px",
            borderTop: "none",
            borderRight: "15px solid transparent",
            borderLeft: "15px solid transparent",
            borderBottom: "15px solid black",
        },
        // "&:hover":{
        //     padding: "20px 0 20px 0px",
        // }

        "&::before": {
            content: "",
            display: "block",
            position: "absolute",
            top: 0,
            right: 14,
            width: 10,
            height: 10,
            bgcolor: "background.paper",
            borderTop: "8px solid black",
            borderBottom: "8px solid black",
            transform: "translateY(-50%) rotate(45deg)",
            zIndex: 1,
        },
        transformOrigin: "280px 13px !important",
        transition:
            "opacity 327ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 218ms cubic-bezier(0.4, 0, 0.2, 1) 0ms !important",
    },
    Latest: {
        display: "row",
        fontSize: "12px",
        textAlign: "left",
        color: "#9c9c9c",
        position: "relative",
        left: 0,
        paddingTop: "10px",
        paddingLeft: "14px",
        lineHeight: "14px",
    },
    stickyHeader: {
        position: "sticky",
        top: 0,
        background: "white",
        zIndex: 2,
        paddingBottom: "7px",
    },
    MarkRead: {
        display: "row",
        fontSize: "12px",
        textAlign: "right",
        paddingRight: "14px",
        color: "#707070",
        position: "relative",
        right: "2px",
        cursor: "pointer",
        paddingTop: "10px",
        lineHeight: "14px",
        "&:hover": {
            textDecoration: "underline",
        },
    },
    // MuiPaper-root MuiMenu-paper
    onChangeSearchInput: {
        "& svg": {
            width: "15px",
            height: "18px",
            cursor: "pointer",
        },
        "& .MuiMenu-paper:after": {
            borderBottomColor: "#f57c00",
        },
    },
    ellipse: {
        width: "6px",
        height: "6px",
        backgroundColor: "#fb9500",
        borderRadius: "50px",
        border: "solid 1px #fb9500",
        marginLeft: "83px",
        marginTop: "15px",
        "&:hover": {
            boxShadow: "0 0 0 3px  #eaeaea",
            "&::before": {
                content: '"Mark as read"',
                display: "block",
                position: "relative",
                color: "white",
                backgroundColor: "#969696",
                opacity: "0.7",
                width: "70px",
                height: "16px",
                fontSize: "10px",
                textAlign: "center",
                borderRadius: "2px",
                boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
                right: "78px",
                bottom: "5px",
                paddingBottom: "18px",
            },
        },
    },
    ellipseEmpty: {
        width: "6px",
        height: "6px",
        color: "white",
        backgroundColor: "#eaeaea",
        borderRadius: "50px",
        border: "solid 1px #eaeaea",
        marginLeft: "83px",
        marginTop: "15px",
        pointerEvents: "fill",
        cursor: "pointer",
        "&:hover": {
            boxShadow: "0 0 0 3px  #eaeaea",
            "&::before": {
                content: '"Mark as unread"',
                position: "relative",
                backgroundColor: "#969696",
                opacity: "0.7",
                display: "block",
                width: "79px",
                height: "16px",
                whiteSpace: "nowrap",
                fontSize: "10px",
                textAlign: "center",
                boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
                borderRadius: "2px",
                right: "83px",
                bottom: "5px",
                paddingBottom: "18px",
            },
        },
    },
    hoursAgo: {
        fontSize: "12px",
        textAlign: "left",
        color: "#969696",
    },
    menuItem: {
        paddingLeft: "14px",
        paddingRight: "14px",
        "&:hover": {
            width: "100%",
        },
    },
    notificationFooter: {
        textAlign: "center",
        color: "#212121",
        fontSize: "12px",
        marginTop: "auto",
        paddingTop: "5px",
        paddingBottom: "15px",
    },
    emptyBell: {
        paddingTop: "16px",
        minHeight: "284px",
        position: "relative",
        bottom: "20px",
    },
    emptyNotifyText: {
        color: "#212121",
        fontSize: "14px",
        lineHeight: "15px",
        paddingTop: "20px",
        paddingLeft: "15px",
    },
    emptyNotifySub: {
        color: "#707070",
        fontSize: "12px",
        paddingLeft: "15px",
    },
    showTriangle: {
        display: "block",
        position: "absolute",
        top: 56,
        right: 22,
        width: 12,
        height: 12,
        background: "white",
        transform: "translateY(-50%) rotate(45deg)",
    },
});
